export enum SearchParams {
  CAR = "car",
  LOCATION = "location",
  LAT = "lat",
  LNG = "lng",
  CHECKIN = "checkin",
  CHECKOUT = "checkout",
  MIN_PRICE = "min-price",
  MAX_PRICE = "max-price",
  BODY_STYLE = "body-style",
  POWERTRAIN = "powertrain",
  MIN_SEATS = "min-seats",
  TRANSMISSION = "transmission",
}
